import { render, staticRenderFns } from "./dajin.vue?vue&type=template&id=76e7ddfa&scoped=true"
import script from "./dajin.vue?vue&type=script&lang=js"
export * from "./dajin.vue?vue&type=script&lang=js"
import style0 from "./dajin.vue?vue&type=style&index=0&id=76e7ddfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e7ddfa",
  null
  
)

export default component.exports